export function getDepartmentFilterConfig({ user, isSuperAdmin, departments = [] }) {
  const normalizedDepartments = Array.from(new Set((departments || []).filter(Boolean)));
  const userDepartment = user?.department || '';
  const isScopedAdmin = Boolean(
    (user?.role === 'manager-admin' || user?.role === 'admin') &&
    !isSuperAdmin &&
    userDepartment
  );

  if (isScopedAdmin) {
    return {
      options: [userDepartment],
      selectedDepartment: userDepartment,
      showAllDepartmentsOption: false,
      disableSelection: true
    };
  }

  return {
    options: normalizedDepartments,
    selectedDepartment: '',
    showAllDepartmentsOption: true,
    disableSelection: false
  };
}
